import * as React from 'react'

import { Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Props {
  analytic?: Analytic<number | string | null>
}

const AnalyticError = ({ analytic }: Props): JSX.Element | null => {
  const [toggle, setToggle] = useToggle(false)

  if (!analytic || !analytic.error) {
    return null
  }

  const message = analytic.error.message
  return (
    <Tooltip.Dialog open={toggle} toggle={setToggle} attachment="top center" label={message}>
      <Text.Normal weight="normal" color="grey600">
        {analytic?.error?.value}
      </Text.Normal>
    </Tooltip.Dialog>
  )
}

export default observer(AnalyticError)
